import { highlights } from "@/mocks/quotes";

export default function Hero() {
  return (
    <section id="top" className="relative">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20editorial%20still%20life%20of%20stacked%20vintage%20newspapers%20and%20typewriter%20documents%20on%20a%20parchment%20cream%20desk%2C%20deep%20pine%20green%20and%20amber%20ink%20accents%2C%20a%20round%20verification%20stamp%2C%20soft%20directional%20window%20light%2C%20minimalist%20modern%20newsroom%20archive%20flat-lay%2C%20textured%20paper%20detail%2C%20elegant%20and%20calm&width=1600&height=900&seq=qz-hero-01&orientation=landscape"
          alt="求真核查站编辑部档案背景图，暖色报纸与文档叠放"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/92 to-background-50/35"></div>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-32 pb-16 md:pt-44 md:pb-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium border border-accent-200">
            <i className="ri-verified-badge-line text-sm"></i>
            在线黑料事实核查 · 辟谣专区 · 可信度分析
          </span>

          <h1 className="mt-6 text-3xl md:text-5xl lg:text-[56px] leading-tight font-bold tracking-tight text-foreground-950">
            让每一条{" "}
            <span className="relative text-primary-700">
              在线黑料
              <span className="absolute -bottom-1 left-0 right-0 h-[3px] bg-accent-400 rounded-full"></span>
            </span>
            <br className="hidden md:block" />
            先求证，再转发
          </h1>

          <p className="mt-6 text-base md:text-lg leading-relaxed text-foreground-700 max-w-2xl">
            我们专注<span className="font-medium text-foreground-900">在线黑料真假鉴定</span>
            与<span className="font-medium text-foreground-900">事实核查</span>
            ，坚持多方求证与信息源核对，对热门争议做可信度分析。辟谣专区与证据梳理助你过滤不实信息，
            理性判断每一条黑料的真实成分。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#reports"
              className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 text-sm font-medium transition-colors"
            >
              查看最新核查结论
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#contact"
              className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-background-50/90 hover:bg-background-100 text-foreground-900 border border-foreground-200 px-6 py-3 text-sm font-medium transition-colors"
            >
              <i className="ri-error-warning-line"></i>
              提交待核实线索
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-600 mr-1">核查样本覆盖：</span>
            {["食品安全", "财经消费", "数码科技", "社会民生"].map((t) => (
              <span
                key={t}
                className="px-2.5 py-1 rounded-full bg-background-100 border border-background-200 text-foreground-700 text-xs"
              >
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="relative border-y border-background-200 bg-background-100/70">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <dl className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-background-200">
            {highlights.map((h) => (
              <div key={h.label} className="bg-background-100 py-6 md:py-8 px-4 text-center">
                <dd className="font-heading text-2xl md:text-3xl font-bold text-primary-700">
                  {h.num}
                </dd>
                <dt className="mt-1 text-xs md:text-sm text-foreground-600">{h.label}</dt>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}